import { AdCampaign } from '@/interfaces';
import React from 'react';
import { Typography } from '../typography';

export const GoogleSearchCard: React.FC<AdCampaign> = ({
	copy,
	title,
	link,
	magic_link_text,
	magic_link,
}) => {
	return (
		<div className="bg-white rounded-2xl p-4 border border-grey-100 max-w-full 2xl:max-w-[440px]">
			<Typography type="bold-16" className="text-blue-link text-left">
				<p className="truncate max-w-[408px]">{title}</p>
			</Typography>
			<div className="flex items-center gap-x-2 mt-2 mb-[13px] h-[25px]">
				<span className="border border-main-green py-1 px-0.5">
					<Typography type="semibold-14" className="text-main-green">
						Ad
					</Typography>
				</span>
				<Typography
					type="semibold-14"
					className="text-main-green truncate max-w-fit"
				>
					{link}
				</Typography>
			</div>
			<div className="max-h-[110px] overflow-hidden">
				<Typography
					html={copy.replace(
						/Attorney Advertising/g,
						'<br/><br/>Attorney Advertising'
					)}
					type="regular-14"
					className="text-opacity-black text-sm font-normal max-h-min text-left"
				/>
			</div>
			<Typography type="regular-14" className="!text-[#6E6A73] mt-4">
				{magic_link_text} <span className="text-blue-link">{magic_link}</span>
			</Typography>
			<div className="grid grid-cols-2 mt-4">
				<Typography type="regular-14" className="text-main-blue-dark">
					Lawyers
				</Typography>
				<Typography type="regular-14" className="text-main-blue-dark">
					Netflix
				</Typography>
			</div>
		</div>
	);
};
